export default __webpack_public_path__ + "static/media/05.38a1f709.jpg";